import { Toaster as Sonner, toast } from "sonner";

const Toaster = ({ ...props }) => {
  return (
    <Sonner
      theme="dark"
      richColors
      position="top-right"
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:border-[rgba(212,175,55,0.18)] group-[.toaster]:bg-[#0f1217] group-[.toaster]:text-[#f6f1e6] group-[.toaster]:shadow-[0_18px_50px_rgba(0,0,0,0.55)]",
          description: "group-[.toast]:text-[#c9c2b4]",
          actionButton: "group-[.toast]:bg-[#d4af37] group-[.toast]:text-[#0b0d10]",
          cancelButton: "group-[.toast]:bg-[#141923] group-[.toast]:text-[#f6f1e6]",
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
